import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-favorite',
  templateUrl: './icon-favorite.component.html',
  styleUrls: ['./icon-favorite.component.scss']
})
export class IconFavoriteComponent implements OnInit {
  @Input() color: string = '#262628';
  @Input() size: number = 18;

  constructor() { }

  ngOnInit() {
  }

}
